<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     布局模板 Frame 组件
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="the-layout-frame" :class="{ 'is-collapse': $route.meta.layout || (!$route.meta.layout && isCollapse) }">
    <el-scrollbar :native="false" class="frames" view-class="el-scrollbar-view">
      <div class="frame-container">
        <!-- home-frame -->
        <div class="home flex-center" role="button" :class="{ 'is-collapse': $route.meta.layout || (!$route.meta.layout && isCollapse), 'is-active': $route.name === 'HomeIndex' }" @click="homeSelect()">
          <div v-show="!$route.meta.layout && !isCollapse" class="logo flex-center">
            <img v-if="logo" :src="logo">
            <img v-else src="@/assets/logo.png">
          </div>

          <div v-show="$route.meta.layout || (!$route.meta.layout && isCollapse)" class="icon flex-center">
            <i class="iconfont icon-Home home-icon"></i>
          </div>
        </div>

        <!-- frames -->
        <el-menu ref="menu" :default-active="defaultActive" class="el-menu-vertical" :collapse="!!$route.meta.layout || (!$route.meta.layout && isCollapse)" @select="onSelect">
          <template v-for="frame in frames">
            <div
              v-if="frame.meta.show === 1"
              :key="frame.meta.frame"
              class="frame-item"
              >
              <el-menu-item v-if="!frame.children || !frame.children.length || frame.children.length == 1 || frame.meta.frame == 'Pm'" :index="frame.name" @click="frameSelect(frame)">
                <div class="frame menu-item-frame" :class="{ 'is-active': frame.meta.frame === defaultActive }">
                  <div class="icon">
                    <i :class="'iconfont home-icon icon-' + frame.meta.icon"></i>
                  </div>
                  <span slot="title" class="title" :class="{ 'collapse-title': $route.meta.layout || (!$route.meta.layout && isCollapse) }">{{ frame.meta.title }}</span>
                </div>
              </el-menu-item>
              <el-submenu v-else :index="frame.name" :class="{ 'is-active': frame.meta.frame === defaultActive }">
                <template slot="title">
                  <div class="frame" :class="{ 'is-active': frame.meta.frame === defaultActive }" @click="frameSelect(frame)">
                    <div class="icon flex-center">
                      <i :class="'iconfont home-icon icon-' + frame.meta.icon"></i>
                    </div>
                    <span slot="title" class="title" :class="{ 'collapse-title': $route.meta.layout || (!$route.meta.layout && isCollapse) }">{{ frame.meta.title }}</span>
                  </div>
                </template>
                <el-menu-item-group> 
                  <menu-section-link v-for="menu in frame.children" :key="menu.name" :to="menu.path" :meta="menu.meta">
                    <el-menu-item v-if="menu.meta.show === 1" :index="menu.name">
                      <span :class="{ 'activeSubitem': menu.name === $route.name, 'padding-left': !(!!$route.meta.layout || (!$route.meta.layout && isCollapse)) }">{{ menu.meta.title }}</span>
                    </el-menu-item>
                  </menu-section-link>
                </el-menu-item-group>
              </el-submenu>
            </div>
          </template>

        </el-menu>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>

export default {
  name: 'TheLayoutFrame',
  components: {
    MenuSectionLink: () => import('./components/MenuSectionLink')
  },
  data() {
    return {      
    }
  },
  computed: {
    route() {
      return this.$route
    },

    isCollapse() {
      return this.$store.state.commonStore.collapse
    },

    defaultActive() {
      return this.$store.getters.currentFrame
    },

    logo() {
      return this.$store.state.godStore.logo
    },

    activeMenu() {
      return this.$store.getters.currentMenus
    },

    frames() {
      return this.$store.getters.dynamicRoutes
    }
  },

  created() {
  },

  methods: {
    homeSelect() {
      this.$router.push({ name: 'HomeIndex' })
    },
    
    frameSelect(frame) {
      // this.$router.push({ name: frame.meta.frame })
    },

    onSelect(index, path) {
      if (path.indexOf(this.$route.name) > -1) {
        this.$router.push({ path: '/refresh' })
      } else {
        this.$router.push({ name: index })
      } 
    },

  }
}
</script>

<style lang="scss" slot-scoped>
$--color-primary: #07c160;
$--menu-inverse-bg: #252a2f;
$--menu-inverse-item-color: #aaa;
$--menu-inverse-item-hover-fill: mix(#000, $--menu-inverse-bg, 20%);

$--layout-menu-item-height: 50px;

.el-menu, .el-menu--vertical {
  background-color: $--menu-inverse-bg;
  border-right: 0;
  .el-submenu__title {
    height: $--layout-menu-item-height;
    line-height: $--layout-menu-item-height;
    color: $--menu-inverse-item-color;
    border-left: 2px solid transparent;
    padding: 0 5px 0!important;
    padding-left: 0!important;
    padding-right: 0!important;
    &:hover, &focus {
      background-color: $--menu-inverse-item-hover-fill;
      color: #fff;
    }
  }
  .el-menu-item-group__title {
    padding-left: 0!important;
    padding: 0px;
  }
  .el-menu--popup-right-start {
    margin-left: 0;
    margin-right: 0;
  }
  .el-menu--popup {
    min-width: 100px;
    padding: 0;
  }
  .el-menu-item {
    height: $--layout-menu-item-height;
    line-height: $--layout-menu-item-height;
    color: $--menu-inverse-item-color;
    padding-left: 0px!important;
    padding-right: 0px!important;
    min-width: 100px;
    text-align: left;
    &:hover, &:focus {
      background-color: $--menu-inverse-item-hover-fill;
    }
    // &.is-active {
      // color: $--color-primary;
      // background-color: $--menu-inverse-item-hover-fill;
    // }
  }
  .is-active {
    .el-submenu__title {
      border-left: 2px solid $--color-primary;
    }
    .el-submenu__icon-arrow {
      color: $--color-primary;
    }
  }
  .el-submenu__icon-arrow {
    right: 10px;
  }
  
}

.el-menu--collapse {
  width: 60px;
  .el-submenu__title {
    padding-right: 0px!important;
  }
  .el-submenu__icon-arrow {
    display: none;
  }
}
.el-menu--vertical .el-menu-item {
  text-align: left;
  padding-left: 30px!important;
  padding-right: 30px!important;
}


.the-layout-frame {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 160px;
  border-top: 1px solid $--menu-inverse-bg;
  background-color: $--menu-inverse-bg;
  overflow-x: hidden;
  height: 100%;
  transition: all .2s;
  .frame-container {
    border: 0;
    margin-top: -1px;
    background-color: $--menu-inverse-bg;
    .home {
      width: 158px;
      height: 60px;
      color: $--menu-inverse-item-color;
      border-left: 2px solid transparent;
      transition: all .2s;
      .logo {
        margin: 5px;
        img {
          max-height: 50px;
          max-width: 148px;
        }
      }
      .icon {
        width: 58px;
        font-size: 24px;
        line-height: 1em;
        color: inherit;
        transition: all .2s;
        .home-icon {
          font-size: 24px;
        }
      }
      &:hover, &:focus {
        color: #fff;
        background-color: $--menu-inverse-item-hover-fill;
      }
      &.is-active {
        color: $--color-primary;
        border-left: 2px solid $--color-primary;
      }
      &.is-collapse {
        width: 58px;
      }
    }
    .frame-item {
      cursor: pointer;
      text-align: center;
      line-height: 1em;
      padding: 0;
      color: $--menu-inverse-item-color;
      -webkit-transition: border-color .2s, background-color .2s, color .2s;
      transition: border-color .2s, background-color .2s, color .2s;
      display: flex;
      align-items: center;
      .icon {
        width: 58px;
        padding-right: 2px;
        font-size: 24px;
        line-height: 1em;
        color: inherit;
        transition: all .2s;
        >.iconfont {
          font-size: 24px;
          margin: 0 17px;
        }
      }
      .title {
        width: 100px;
        font-size: 14px;
        line-height: 16px;
        display: flex;
        &.collapse-title {
          width: 5px;
        }
      }
      &:hover, &:focus {
        color: #fff;
        background-color: $--menu-inverse-item-hover-fill;
      }
      &.is-active {
        color: $--color-primary;
        border-left: 2px solid $--color-primary;
      }
      .frame {
        height: $--layout-menu-item-height;
        line-height: $--layout-menu-item-height;
        color: $--menu-inverse-item-color;
        display: flex;
        align-items: center;
        &:hover, &:focus {
          background-color: $--menu-inverse-item-hover-fill;
        }
        &.is-active {
          color: $--color-primary;
          .icon {
            .iconfont {
              color: $--color-primary;
            }
          }
        }
        
      }
      .menu-item-frame {
        border-left: 2px solid transparent;
        &.is-active {
          border-left: 2px solid $--color-primary;
        }
      }
    }
  }
  >.el-scrollbar {
    height: 100%;
    >.el-scrollbar__wrap {
      overflow-x: hidden;
      >.el-scrollbar__view {
        padding: 0 0 30px 0;
      }
    }
  }
}

.activeSubitem {
  color: $--color-primary;
}
.padding-left {
  margin-left: 40px;
  margin-right: -40px;
}

.the-layout-frame.is-collapse {
  width: 60px;
  >.el-scrollbar {
    height: 100%;
    >.el-scrollbar__wrap {
      overflow-x: hidden;
      >.el-scrollbar__view {
        padding: 0 0 60px 0;
      }
    }
  }
}
</style>
